import React from "react";
import icoEvents from '../../assets/img/126PX/icoEvents.png';

export default (props) => {
    return (
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '20px', color: '#c3c3c3', fontSize: '16px'}}>
            <img src={icoEvents} />

            {props.noRowsMessageFunc()}
        </div>
    )
}